<!-- 图片上传组件 -->
<style lang="scss" scoped>
.img-upload {
  flex: 1;
}

.img-upload-input {
  display: none;
}

.img-upload-empty {
  display: flex;
  align-items: center;
  border: 1px dashed $color-primary;
  border-radius: 2px;
  height: 100%;
  text-align: center;
  background: #FFFFFF;
  cursor: pointer;
}

.img-upload-empty-disabled {
  cursor: not-allowed;
  background-color: #F5F5F5;
}

.img-upload-empty-dragover {
  border-width: 2px;
  background: rgba($color-primary, .1);
}

.img-upload-empty-content {
  flex: 1;
}

.img-upload-icon-plus {
  color: $color-primary;
}

.img-upload-empty-text {
  margin-top: 4px;
  padding: 0 10px;
  font-size: 14px;
  color: $darker-text;
  line-height: 16px;
}

.img-upload-preview-container {
  position: relative;
  border: 1px solid $base-border;
  border-radius: 2px;
  padding: 10px;
  height: 100%;
  background: #FFFFFF;
}

.img-upload-preview-img {
  width: 100%;
  height: 100%;
}

.img-upload-preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-upload-preview-zip {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;
  cursor: pointer;

  .img-upload-icon-zip {
    color: #FFFFFF;
  }

  .img-upload-icon-pdf {
    color: #999999;
  }

  .img-upload-file-name {
    margin-top: 8px;
    color: $darker-text;
    line-height: 1;
  }
}

.preview-mask-container {
  position: absolute;
  top: 0;
  left: 0;

  // padding: 10px;
  width: 100%;
  height: 100%;

  &:hover .preview-mask {
    display: flex;
  }
}

.preview-mask {
  display: none;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #FFFFFF;
  background: rgba($basic-black, .5);
  box-shadow: 0 0 4px rgb(0 0 0 / 10%);
}

.img-upload-preview-icon,
.img-upload-delete-icon {
  cursor: pointer;

  &:hover {
    color: $primary-text-hover;
  }
}

.img-upload-delete-icon {
  margin-left: 20px;
}
</style>

<style lang="scss">
.el-form-item.is-error .img-upload-empty {
  border-color: $primary-text-hover;
  background: $overlay-background;
}
</style>

<template>
  <div
    class="img-upload"
    :style="{height: `${height}px`, width: `${width}px`}"
  >
    <!-- input -->
    <input
      ref="inputRef"
      :key="inputKey"
      type="file"
      class="img-upload-input"
      :accept="accept"
      @change="handleInputChange"
    >
    <!-- 未上传文件 -->
    <div
      v-if="!modelValue"
      v-loading="uploading"
      class="img-upload-empty"
      :class="{
        'img-upload-empty-dragover': dragover,
        'img-upload-empty-disabled': !uploadable,
      }"
      @click="handleClick"
      @drop.prevent="onDrop"
      @dragover.prevent="onDragover"
      @dragleave.prevent="dragover = false"
    >
      <div class="img-upload-empty-content">
        <icon class="img-upload-icon-plus" type="yiyuan-plus" size="30" />
        <div class="img-upload-empty-text">
          <slot name="empty">
            {{ emptyText }}
          </slot>
        </div>
      </div>
    </div>
    <!-- 已上传文件 -->
    <div v-else class="img-upload-preview-container">
      <!-- 文件类型 -->
      <div v-if="isZip || isPdf" class="img-upload-preview-zip">
        <icon
          v-if="isZip"
          class="img-upload-icon-zip"
          type="yiyuan-icon-zip"
          size="38"
        />
        <icon
          v-if="isPdf"
          class="img-upload-icon-pdf"
          type="yiyuan-icon-pdf"
          size="30"
        />

        <span class="img-upload-file-name">{{ fileName }}</span>
      </div>

      <!--
        <div v-if="isZip || isPdf" class="zip-box">
        <icon
        v-if="isZip"
        class="img-upload-icon-zip"
        type="icon-zip"
        size="38"
        />
        <icon
        v-if="isPdf"
        class="img-upload-icon-zip"
        type="sdicon-icon-pdf"
        size="30"
        />
        <span class="img-upload-zip-name">{{ fileName }}</span>
        </div>
      -->

      <!-- 视频类型 -->
      <video
        v-else-if="isVideo"
        ref="videoRef"
        class="img-upload-preview-video"
        :src="previewUrl"
      />
      <el-image
        v-else
        ref="imageRef"
        class="img-upload-preview-img"
        :fit="imageFit"
        :src="previewUrl"
        :preview-src-list="[previewUrl]"
      />
      <div class="preview-mask-container">
        <div class="preview-mask">
          <icon
            class="img-upload-preview-icon"
            :type="isZip ? 'yiyuan-download' : 'yiyuan-eye'"
            size="32"
            title="预览"
            @click="preview"
          />
          <icon
            v-if="!disabled"
            class="img-upload-delete-icon"
            type="yiyuan-delete"
            size="32"
            title="删除"
            @click="removeFile"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- 视频预览 -->
  <PreviewVideoDialog ref="previewVideoDialogRef" />
</template>

<script setup lang="jsx">
import { upload } from '@/utils/oss'
import { OSS_DIR } from '@/constants/common'
import { useFormItem, useDisabled, ElMessageBox,ElMessage } from 'element-plus'
import { ref, computed, watch, onBeforeUnmount } from 'vue'
// import { ElMessage } from '@/components/el-message/index'
import PreviewVideoDialog from '../preview-video-dialog/preview-video-dialog.vue' // 视频预览组件

const props = defineProps({
  // 图片的 src，没有图片时为空字符串
  modelValue: {
    type: String,
    require: true
  },
  // 未上传文件时的提示文字，也可用 empty slot
  emptyText: {
    type: String,
    default: '点击或拖拽图片至此上传图片'
  },
  imageFit: {
    type: String,
    default: 'cover'
  },
  disabled: Boolean, // 是否禁用
  // 接受的文件类型
  accept: {
    type: String,
    // https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
    default: '.jpeg,.jpg,image/png'
  },
  isPdf: Boolean, // 是否上传PDF
  isZip: Boolean, // 是否上传文件
  isVideo: Boolean, // 是否上传视频
  beforeUpload: Function, // 上传前的回调函数, 返回 false 可以阻止上传
  onSuccess: Function, // 上传成功的回调函数
  sizeLimit: Number, // 限制的文件大小，单位为 M
  // 宽度
  width: {
    type: [Number, String],
    default: 160
  },
  // 高度
  height: {
    type: [Number, String],
    default: 100
  },
  // 上传文件夹
  dir: {
    required: true,
    type: String,
    validator(dir) {
      const isValid = Object.values(OSS_DIR).some(d => d === dir)
      if (import.meta.env.DEV && !isValid) {
        const keys = Object
          .keys(OSS_DIR)
          .map(d => `OSS_DIR.${d}`)
          .join('、')
        // eslint-disable-next-line no-console
        console.error(`[img-upload]dir 属性必须为 ${keys} 其中一个`)
      }
      return isValid
    }
  }
})

// data
const dragover = ref(false) // 是否鼠标悬浮
const tempUrl = ref('') // 通过 URL.createObjectURL 创建的临时 url
const uploading = ref(false) // 是否正在上传
const inputKey = ref(0) // input 的 key
const fileName = ref('') // 已上传文件的文件名

const emit = defineEmits(['update:modelValue', 'change'])

// 销毁组件前，回收 url
onBeforeUnmount(() => {
  tempUrl.value && URL.revokeObjectURL(tempUrl.value)
})

// 表单 item
const elFormItem = useFormItem()

// 是否禁用
const disabled = useDisabled()
// 预览链接
const previewUrl = computed(() => props.modelValue || tempUrl.value)
// 当前是否可上传
const uploadable = computed(() => !disabled.value && !uploading.value)

// input 元素的 ref
const inputRef = ref()
// 点击
const handleClick = () => {
  if (uploadable.value) {
    inputRef.value.click()
  }
}
// 清空 input 的值
const clearFile = () => {
  inputRef.value && (inputRef.value.value = '')
  // IE10 下 input.value = '' 无效，故在此将其重新渲染
  if (inputRef.value?.value) {
    inputKey.value++
  }
}
watch(() => props.modelValue, val => {
  // 触发表单校验
  elFormItem.formItem && elFormItem.formItem.validate('change')
  // 返现数据时给文件名赋值
  if (!fileName.value) {
    fileName.value = val ? val.substring(val.lastIndexOf('/') + 1) : ''
  }
  if (!val) {
    clearFile()
  }
}, { immediate: true })

// 验证文件
const validateFiles = files => {
  if (props.accept) {
    files = [].slice.call(files).filter(file => {
      const { type, name } = file
      const extension = name.indexOf('.') > -1
        ? `.${name.split('.').pop()}`
        : ''
      const baseType = type.replace(/\/.*$/, '')
      return props.accept.split(',')
        .map(t => t.trim())
        .filter(Boolean)
        .some(acceptedType => {
          if (/\..+$/.test(acceptedType)) {
            return extension === acceptedType
          }
          if (/\/\*$/.test(acceptedType)) {
            return baseType === acceptedType.replace(/\/\*$/, '')
          }
          if (/^[^/]+\/[^/]+$/.test(acceptedType)) {
            return type === acceptedType
          }
          return false
        })
    })
    if (!files.length) {
      ElMessage.warning('不支持该文件类型')
    }
  }
  if (!files || !files.length) return
  const file = files[0]
  if (props.sizeLimit) {
    // eslint-disable-next-line no-magic-numbers
    const fileSize = file.size / 1024 / 1024
    if (fileSize >= props.sizeLimit) {
      ElMessage.error(`上传的文件大小不能超过 ${props.sizeLimit}M`)
      clearFile() // 上传完清空,解决重复上传文件不触发change事件
      return
    }
  } else if (typeof props.beforeUpload === 'function' && !props.beforeUpload(file)) {
    return
  }
  return file
}
// 上传文件
const uploadFiles = async files => {
  const fileToUpload = validateFiles(files)
  if (!fileToUpload) {
    return
  }
  uploading.value = true
  elFormItem.formItem && elFormItem.formItem.clearValidate()
  try {
    const url = await upload(fileToUpload, props.dir)
    fileName.value = files[0]?.name
    // onSuccess 可以返回一个 promise，如果返回 promise，上传结果会取决于 promise 最终的状态
    try {
      typeof props.onSuccess === 'function' && await props.onSuccess(url, fileToUpload)
      emit('update:modelValue', url)
      emit('change', url)
    } catch (e) {
      // onSuccess 函数报错
    }
  } catch (e) {
    ElMessage.error('上传失败')
  } finally {
    uploading.value = false
    clearFile() // 上传完清空,解决重复上传文件不触发change事件
  }
}
// 点击上传文件
const handleInputChange = e => {
  const { files } = e.target
  if (!files || files.length === 0) return
  uploadFiles(files)
}
// 拖拽是鼠标悬浮
const onDragover = () => {
  if (uploadable.value) {
    dragover.value = true
  }
}
// 拖拽释放鼠标
const onDrop = e => {
  if (!uploadable.value) return
  dragover.value = false
  uploadFiles(e.dataTransfer.files)
}

const imageRef = ref()
// 打开图片预览框
const preview = () => {
  if (props.isZip || props.isPdf) {
    window.open(previewUrl.value, '_blank')
  } else if (props.isVideo) {
    previewVideo()
  } else {
    imageRef.value.$el.querySelector('img').click()
  }
}
// 删除文件
const removeFile = () => {
  ElMessageBox.confirm('确定要删除吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      clearFile()
      emit('update:modelValue', '')
      emit('change', '')
      ElMessage.success('删除成功')
    })
    .catch(() => {
      // 取消删除
    })
}

const previewVideoDialogRef = ref(null)
// 打开视频预览
const previewVideo = () => {
  previewVideoDialogRef.value.init({
    url: previewUrl.value
  })
}
</script>
